var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "layoutTop" }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-10 offset-md-1" }, [
            _c(
              "div",
              { staticClass: "panel21 panel-default float-none" },
              [
                _c("div", { staticClass: "panel-heading" }, [
                  _c(
                    "h4",
                    { staticClass: "content-block labelAccordionForm" },
                    [
                      _c("img", {
                        staticClass: "formIcon",
                        attrs: {
                          src: require("../../assets/static/images/icons/gearwheels.png"),
                        },
                      }),
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("rights.rights")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("rights-list", {
                  key: _vm.$engine.user.get().id,
                  staticClass: "pl-4",
                  attrs: {
                    userID: parseInt(_vm.$engine.user.get().id),
                    userRights: _vm.userRights,
                    isMyRightsPage: "",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isChangeable()
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-3 offset-md-9" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "milkyBlockBlack button-action firstButtonMarginTop",
                        attrs: { round: "" },
                        on: { click: _vm.changeApplicationSettings },
                      },
                      [
                        _c("i", { staticClass: "icon fa fa-save" }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "toolbarPageBottomBlank" }),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-2 offset-md-7" }, [
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }